import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State { return { error }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Portal runtime error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="fatal-error" id="main-content">
      <p className="eyebrow">Recuperación de la aplicación</p>
      <h1>No fue posible mostrar esta sección</h1>
      <p>El incidente quedó registrado en el navegador. Recarga la sección para intentar recuperar la sesión.</p>
      <button type="button" onClick={() => window.location.reload()}>Recargar página</button>
    </main>;
  }
}
